import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export function reduceSuggestionsIntoNestedSuggestions(output, suggestion) {
  var nestingConfig = suggestion.nestingConfig;
  if (nestingConfig) {
    var existingIndex = output.findIndex(function (s) {
      var _s$nestingConfig;
      return ((_s$nestingConfig = s.nestingConfig) === null || _s$nestingConfig === void 0 ? void 0 : _s$nestingConfig.parentTitle) === nestingConfig.parentTitle;
    });
    if (existingIndex === -1) {
      var _suggestion$nestingCo;
      var parentNestingConfig = _objectSpread({}, nestingConfig);
      delete parentNestingConfig.shortTitle;
      output.push(_objectSpread(_objectSpread({}, suggestion), {}, {
        testId: nestingConfig.parentTestId,
        label: nestingConfig.parentTitle || '',
        nestingConfig: parentNestingConfig,
        childSuggestions: [suggestion],
        value: ((_suggestion$nestingCo = suggestion.nestingConfig) === null || _suggestion$nestingCo === void 0 ? void 0 : _suggestion$nestingCo.parentTitle) || ''
      }));
    } else {
      var _output$existingIndex;
      (_output$existingIndex = output[existingIndex].childSuggestions) === null || _output$existingIndex === void 0 || _output$existingIndex.push(suggestion);
    }
  } else {
    output.push(suggestion);
  }
  return output;
}